"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/OrgSurvey/ReferrerForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');
var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);






var _orgSurvey = require('shared/validation/org/orgSurvey');
var _Form = require('web/components/Form');

var _components = require('web/screens/Signup/components');







const ReferrerForm = ({ onBack, defaultValues, onSubmit }) => {
  const { register, control, watch, handleSubmit, formState } =
    _reacthookform.useForm({
      // Validate a field when it loses focus, then as it is edited to clear the
      // error: never while its first value is still being typed.
      mode: 'onTouched',
      resolver: _orgSurvey.referrerResolver,
      shouldUnregister: true,
      defaultValues: defaultValues || { response: _orgSurvey.referrerOptions[0].value },
    })

  const isOther = watch('response') === _orgSurvey.OTHER_OPTION_KEY
  const { isValid } = formState
  // Shown once they leave the field after typing, never while they type.
  const display = _useFieldErrorDisplay2.default.call(void 0, { responseOther: formState.errors.responseOther })
  const otherError = display.shown('responseOther')

  const submit = (data, e) => {
    _optionalChain([e, 'optionalAccess', _ => _.preventDefault, 'call', _2 => _2()])
    onSubmit(data)
  }

  return (
    _react2.default.createElement('form', { onSubmit: handleSubmit(submit, errs => display.onSubmitErrors(Object.keys(errs))), __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
      , _react2.default.createElement(_components.SignupStepHeader, {
        title: "How did you find us?"    ,
        subtitle: "How did you find out about BloomText?"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "How did you find us?"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
        , _react2.default.createElement(_Form.SimpleSelectController, {
          name: "response",
          control: control,
          options: _orgSurvey.referrerOptions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        )
      )
      ,  isOther && (
        _react2.default.createElement(_Form.InputSection, {
          autoFocus: true,
          title: "Please specify" ,
          placeholder: "E.g. a podcast"  ,
          inputProps: display.bind(register('responseOther')),
          errorMessage: _optionalChain([otherError, 'optionalAccess', _3 => _3.message]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
        )
      )
      , _react2.default.createElement(_components.SignupStepControls, { onBack: onBack, isNextDisabled: !isValid, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}} )
    )
  )
}

exports. default = ReferrerForm
